import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-footer flex-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "حفظ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_page_container = _resolveComponent("page-container")!
  const _component_w_form = _resolveComponent("w-form")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Start Me up ")
      ]),
      _: 1
    }),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event)),
      class: "custom-card",
      preset: "card",
      style: _normalizeStyle(_ctx.bodyStyle),
      title: _ctx.label,
      bordered: false,
      size: "huge",
      segmented: _ctx.segmented
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
            id: "kt_modal_create_api_key_submit",
            class: "btn btn-primary"
          }, _hoisted_4),
          _createElementVNode("button", {
            class: "btn btn-light me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false))
          }, " الغاء ")
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_w_form, {
          label: _ctx.label,
          header: false,
          form: _ctx.model
        }, {
          default: _withCtx(() => [
            _createVNode(_component_page_container, { loading: _ctx.loading }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "default", {
                    model: _ctx.model,
                    OnOpen: _ctx.OnOpenModal
                  })
                ])
              ]),
              _: 3
            }, 8, ["loading"])
          ]),
          _: 3
        }, 8, ["label", "form"])
      ]),
      _: 3
    }, 8, ["show", "style", "title", "segmented"])
  ], 64))
}